<template>
<div class="myorder-wrap">
    <div class="myorder">
        <div class="myorder-content">
            <div class="tips" v-if="isShowT">
                您还没有下单！暂无订单信息
            </div>
            <div v-else class="orderInfo">
                <h2 class="order-header">我的订单</h2>
                <div class="order-content" ref="ordercontent">
                    <div>
                        <div class="order-item" v-for="(item,index) in perData" :key="index">
                            <div class="item-header"  @click="$router.push(`/orderdetails/${item.order_num}`)">
                                <div>
                                    <span class="num">订单号</span>
                                    <span class="numr">{{item.order_num}}</span>
                                </div>
                                <div>{{item.stateN}}</div>
                            </div>
                            <div class="item-content">
                                <div class="content-left"  @click="$router.push(`/orderdetails/${item.order_num}`)">
                                    <img :src="item.photo" alt="">
                                </div>
                                <div class="content-center"  @click="$router.push(`/orderdetails/${item.order_num}`)">
                                    <span class="action_name">{{item.action_name}}</span>
                                    <span class="car_name">型号：{{item.car_name}}</span>
                                </div>
                                <div class="content-right">
                                    <span  @click="$router.push(`/orderdetails/${item.order_num}`)">{{item.order_price}}元</span>
                                    <div class="refund" v-if="item.state == 1" @click="sRefund(item.order_num)">申请退款</div>
                                    <div v-if="item.state == 2" class="refund">退款中</div>
                                </div>

                                



                            </div>
                                <el-dialog
                                    title="申请退款"
                                    :visible.sync="dialogTableVisible"
                                    width="90%"
                                    center
                                    >
                                    <el-form >
                                        <el-form-item label="退款原因" :label-width="formLabelWidth" left>
                                        <el-input type="textarea" v-model="content" autocomplete="off"></el-input>
                                        </el-form-item>
                                        
                                    </el-form>
                                    <div slot="footer" class="dialog-footer">
                                        <el-button @click="dialogTableVisible = false">取 消</el-button>
                                        <el-button type="primary" @click="refundMoney">确 定</el-button>
                                    </div>
                                </el-dialog>    
                            


                        </div>
                    </div>
                    

                </div>
            </div>
        </div>
        <div class="myorder-footer">
            <el-button type="primary" @click="$router.push('/gocat')">回到GO车惠</el-button>
        </div>

    </div>
</div>
</template>

<script>
import BScroll from 'better-scroll';
export default {
    name: 'MyOrder',
    data() {
        return {
            perData: [],
            isShowT: true,
            id:"",
            dialogTableVisible: false,
            content:'',
            formLabelWidth: '80px'

        }
    },
    async created() {
       
        this.getOrderList();
        

    },
    mounted() {

    },
    methods: {

        //获取顶顶那列表
       async getOrderList(){
             const uid = window.localStorage.getItem('uid')
            const result = await this.$http.signUp.getOrderList({
                uid: uid
            });
            if (result.code === 200) {
                let state = {
                    0: '待支付',
                    1: '支付成功',
                    3: '已退款',
                    4:'已完成'
                }

                this.isShowT = false;
                result.data.forEach((item) => {
                    item.stateN = state[item.state];
                })
                this.perData = result.data;
            } else {
                this.$message({
                    message: '暂无订单信息。。。',
                    type: 'error',
                    center: true
                })
                return
            }
        },


        sRefund(id){
            this.dialogTableVisible = true;
            this.id = id
        },
        
        async refundMoney(){
            this.dialogTableVisible = false;
            const uid = window.localStorage.getItem('uid')
            let result = await this.$http.signUp.refundOrder({
                content:this.content,
                uid:uid,
                ordernum:this.id
            })
            console.log(result)
            if(result.code == 200){
                this.getOrderList();
            }
        }
        
    }
}
</script>

<style lang="less">
.myorder-wrap {
    height: 100vh;
    position: relative;
    width: 100%;
    overflow: hidden;
    .myorder {
        font-size: 28px;

        .myorder-content {
            .tips {
                text-align: center;
                padding-top: 50px;
                font-size: 36px;
            }

            .orderInfo {
                padding: 20px;
                width: 100%;

                .order-header {
                    text-align: center;
                    height: 40px;
                    margin-bottom: 50px;
                }

                .order-content {
                    height: calc(100vh - 300px);
                    overflow: hidden;

                    .order-item {
                        margin-bottom: 20px;

                        .item-header {
                            display: flex;
                            justify-content: space-between;

                            .num {
                                margin-right: 30px;
                            }

                            .numr {
                                font-size: 20px;
                                color: #000;
                            }
                        }

                        .item-content {
                            margin-top: 20px;
                            border-top: 1px solid #eee;
                            border-bottom: 1px solid #eee;
                            padding: 20px 0;
                            display: flex;
                            justify-content: space-between;

                            .content-left {
                                width: 30%;

                                img {
                                    width: 100%;
                                }
                            }

                            .content-center {
                                width: 50%;
                                padding-left: 8px;
                                .action_name{
                                    width: 100%;
                                    display: block;
                                    overflow: hidden;
                                    text-overflow:ellipsis; 
                                    white-space: nowrap;
                                    font-size: 28px;
                                }
                                .car_name{
                                    font-size: 24px;
                                }
                            }
                            .content-right{
                                    text-align: center;
                                    .refund{
                                        margin-top:40px;
                                        border: 1px solid #f06e6e;
                                        color: #f06e6e;
                                        padding:4px 10px;
                                        border-radius: 24px;
                                    }    
                            }
                        }
                    }
                }
            }
           .el-dialog--center{
               .el-dialog__title{
                   font-size: 40px;
               }
               .el-form-item__label{
                   font-size: 34px;
                   text-align: center;
               }
               .el-button{
                   font-size: 34px;
               }
               .el-textarea__inner{
                   font-size: 30px;
                   height: 150px;
               }
               
           }
        }

        .myorder-footer {
            position: absolute;
            left: 0;
            bottom: 0;
            height: 100px;
            width: 100%;
            background: #fff;

            .el-button {
                position: absolute;
                left: 0;
                top: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                width: 300px;
                height: 70px;
                font-size: 30px;
            }
        }
    }
}
</style>
